import atimg1 from '../images/team/img-1.jpg'
import atimg2 from '../images/team/img-2.jpg'
import atimg3 from '../images/team/img-3.jpg'
import atimg4 from '../images/team/img-4.jpg'


const Attorneys = [
   {
      Id: '1',
      AtImg: atimg1,
      name: 'Michel Schiff',
      slug: 'Michel-Troat',
      title: 'Co-Founder',
   },
   {
      Id: '2',
      AtImg: atimg2,
      name: 'Barbera Crest',
      slug: 'Barbera-Crest',
      title: 'Business Lawyer',
   },
   {
      Id: '3',
      AtImg: atimg3,
      name: 'Ashley Adams',
      slug: 'Ashley-Adams',
      title: 'Criminal Lawyer',
   },
   {
      Id: '4',
      AtImg: atimg4,
      name: 'Jeffery Roberts',
      slug: 'Jeffery-Roberts',
      title: 'Family Lawyer',
   },
   {
      Id: '5',
      AtImg: atimg2,
      name: 'Jane Cooper',
      slug: 'Jane-Cooper',
      title: 'Divorce Lawer',
   }

]

export default Attorneys;